// @flow

import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaOn } from 'components/styles/_media'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { stayUrl } from 'frontend_core/dist/helpers/url'

export const SiteFooterExternal = styled.div`
  padding: 32px 0;
  background-color: #373737;
  color: #c9c9c9;
  font-size: 13px;
  ${mediaMax.desktop`
    padding: 20px 0 10px;
  `};
`
export const FooterExternalHead = styled.div`
  position: relative;
  padding-bottom: 10px;
  border-bottom: 1px solid #606060;
  overflow: hidden;
`
export const FooterExternalText = styled.p`
  padding-top: 10px;
  font-size: 12px;
  line-height: 1.4;
  clear: both;
  ${mediaMax.desktop`
    margin-bottom: 15px;
  `};
`
export const FooterExternalLink = styled.a`
  color: #c9c9c9;

  &:hover {
    color: #fff;
  }
`
export const FooterExternalIconLabel = styled.span`
  font-size: 12px;
  float: right;
  padding-top: 3px;
  ${mediaOn.desktop`
    width: 100%;
    display: block;
  `};
`
export const FooterExternalIcon = styled.i`
  margin-left: 4px;
`

export default () => (
  <SiteFooterExternal>
    <div className="container">
      <ul>
        <li className="col-xs-12 col-sm-4 col-md-4">
          <FooterExternalHead>
            <FooterExternalLink href={stayUrl('')}>
              <OptimizedImage
                src={imagePath('footer/logo_stay.png')}
                width="192"
                height="15"
                alt="SPACEMARKET STAY"
              />
              <FooterExternalIconLabel>
                民泊・宿泊予約
                <FooterExternalIcon className="fa fa-external-link" />
              </FooterExternalIconLabel>
            </FooterExternalLink>
          </FooterExternalHead>
          <FooterExternalText>
            観光からビジネスまで安心して予約できる民泊物件・宿泊施設を多数掲載
          </FooterExternalText>
        </li>
        <li className="col-xs-12 col-sm-4 col-md-4">
          <FooterExternalHead>
            <FooterExternalLink href="https://blog.spacemarket.com/">
              <OptimizedImage
                src={imagePath('footer/logo_blog.png')}
                width="187"
                height="15"
                alt="SPACEMARKET BLOG"
              />
              <FooterExternalIconLabel>
                開発ブログ
                <FooterExternalIcon className="fa fa-external-link" />
              </FooterExternalIconLabel>
            </FooterExternalLink>
          </FooterExternalHead>
          <FooterExternalText>
            スペースマーケットサービス開発チームによる開発ブログ
          </FooterExternalText>
        </li>
        <li className="col-xs-12 col-sm-4 col-md-4">
          <FooterExternalHead>
            <FooterExternalLink href="https://beyond.spacemarket.com/">
              <OptimizedImage
                src={imagePath('footer/logo_beyond.png')}
                width="87"
                height="15"
                alt="BEYOND"
              />
              <FooterExternalIconLabel>
                利用事例
                <FooterExternalIcon className="fa fa-external-link" />
              </FooterExternalIconLabel>
            </FooterExternalLink>
          </FooterExternalHead>
          <FooterExternalText>
            スペース利用事例やホストへのインタビュー等、生の声をお届け
          </FooterExternalText>
        </li>
      </ul>
    </div>
  </SiteFooterExternal>
)



// WEBPACK FOOTER //
// ./src/components/shared/footer/FooterExternal.jsx